<template>
  <Btn :color="color" :href="$t('licensing.url.trial')" target="blank" data-test-id="license-trial-button">
    {{ $t('licensing.action.trial') }}
  </Btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LicenseTrialAction',

  props: {
    color: {
      type: String,
      default: 'blue',
    },
  },
});
</script>
